import React from "react";
import { AiOutlineApartment, AiOutlineBank, AiOutlineTeam } from "react-icons/ai";
import GroupListScreen from "../GroupListScreen";
import PersonCell from "../PersonCell";
import useGroupBranchOptions from "../useGroupBranchOptions";
import { fetchGroupInstructors } from "../../../services/groupConsole.service";

const nameColumn = {
  title: "Name",
  key: "name",
  render: (r) => (
    <PersonCell
      id={r._id}
      image={r.profile_image}
      firstName={r.first_name}
      lastName={r.last_name}
      subtitle={r.title}
    />
  ),
};

const buildStats = (rows) => {
  const total = rows.length;
  const branches = new Set(rows.map((r) => r.school)).size;
  const departments = new Set(
    rows.map((r) => r.department?.name).filter(Boolean),
  ).size;
  return [
    {
      key: "total",
      label: "Instructors",
      value: total,
      icon: <AiOutlineTeam size={15} />,
      color: "indigo",
    },
    {
      key: "branches",
      label: "Branches",
      value: branches,
      icon: <AiOutlineBank size={15} />,
      color: "sky",
    },
    {
      key: "departments",
      label: "Departments",
      value: departments,
      icon: <AiOutlineApartment size={15} />,
      color: "purple",
    },
  ];
};

const GroupInstructors = () => {
  const branches = useGroupBranchOptions();
  return (
    <GroupListScreen
      title="Instructors"
      queryKey="group-console-instructors"
      fetchFn={fetchGroupInstructors}
      searchPlaceholder="Search by name or employee ID"
      branchOptions={branches.options}
      branchOptionsLoading={branches.isLoading}
      statCards={buildStats}
      pageSize={10}
      columns={[
        nameColumn,
        { title: "Employee ID", dataIndex: "unique_id", align: "center" },
        {
          title: "Department",
          key: "department",
          align: "center",
          render: (r) => r.department?.name || "—",
        },
      ]}
    />
  );
};

export default GroupInstructors;
